export const findItemByKey = (array, key) => {
  if (!key) {
    return null;
  }
  const item = array.find((x) => x.key === key);
  return item?.value ?? key;
};
